import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export function logoutAction(): Promise<ApiResponse<any>> {
  return api.delete<ApiResponse<any>>('/auth/logout')
}
